module.exports = __webpack_public_path__ + "static/5StoryRichIndieGamesCuteFroggyProtagonists1-0703cd5b29cd2d8ea915765613d80cbe.png";